import moment from 'moment'

const LOCAL_DATE_STRING_FORMAT = "YYYY-MM-DDTHH:mm:ss";

/**
 * Converts a given date, time strings into a localized date string format.
 *
 * @param {string} dateString - The date in YYYY-MM-DD format (e.g., "2025-03-12").
 * @param {string} timeString - The time in HH:mm format (e.g., "14:30").
 * @returns {string} A localized date string formatted based on "YYYY-MM-DDTHH:mm:ss".
 */
export const toLocalDateString = (dateString, timeString) => {
  const isoString = `${dateString}T${timeString}:00`;
  return moment(isoString).format(LOCAL_DATE_STRING_FORMAT);
};

/**
 * Adds a specified amount of time to the given date string in a customizable format.
 *
 * @param {string} dateString - The date in "YYYY-MM-DDTHH:mm:ss" format (e.g., "2025-03-12T12:00:00").
 * @param {number} amount - The amount of time to add (default is 1).
 * @param {'days' | 'months' | 'years'} unit - The unit of time to add (default is 'day').
 * @returns {string} A new date string in the specified format with the time added.
 */
export const addToDate = (dateString, amount = 1, unit = 'days') => {
  return moment(dateString, LOCAL_DATE_STRING_FORMAT).add(amount, unit).format(LOCAL_DATE_STRING_FORMAT);
};

/**
 * Converts a date string to a local ISO-like string format.
 *
 * @param {string} dateString - The date string to format (must be in "YYYY-MM-DDTHH:mm:ss").
 * @returns {string} A formatted date string in "YYYY-MM-DDTHH:mm:ss" format.
 * @throws {Error} If the input date string is invalid or not in the expected format.
 */
export const formatToLocalISOString = (dateString) => {
  if (!moment(dateString, LOCAL_DATE_STRING_FORMAT, true).isValid()) {
      throw new Error(`Invalid date string. Expected format is "${LOCAL_DATE_STRING_FORMAT}".`);
  }
  return moment(dateString, LOCAL_DATE_STRING_FORMAT).format(LOCAL_DATE_STRING_FORMAT);
};